import React, {Component} from "react";
import {connect} from "react-redux";
import {filterProducts, sortProducts} from "../../../../actions/productActions";


const Filter = (props) => {
    return (
        <div className="row text-center">
            <div className="col-md-4"><h6>{`${props.filteredProducts.length} products found.`}</h6></div>
            <div className="col-md-4 text-left">
                <label>
                    <h6>Order By Price</h6>
                    <select
                        className="form-control"
                        value={props.sort}
                        onChange={(event) => {
                            props.sortProducts(
                                props.filteredProducts,
                                event.target.value
                            );
                        }}
                    >
                        <option value="">Select</option>
                        <option value="lowestprice">Lowest to highest</option>
                        <option value="highestprice">Highest to lowest</option>
                    </select>
                </label>
            </div>
            <div className="col-md-4 text-left">
                <label>
                    {" "}
                    <h6>Filter Size</h6>
                    <select
                        className="form-control"
                        value={props.size}
                        onChange={(event) => {
                            props.filterProducts(
                                props.products,
                                event.target.value
                            );
                        }}
                    >
                        <option value="">ALL</option>
                        <option value="x">XS</option>
                        <option value="s">S</option>
                        <option value="m">M</option>
                        <option value="l">L</option>
                        <option value="xl">XL</option>
                        <option value="xxl">XXL</option>
                    </select>
                </label>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    products: state.products.items,
    filteredProducts: state.products.filteredItems,
    size: state.products.size,
    sort: state.products.sort,
});
export default connect(mapStateToProps, {filterProducts, sortProducts})(
    Filter
);
